import ShareIcon from 'assets/icons/share.svg';
import CustomTooltip from 'components/Tooltip';
import { onShareURLClick } from 'utils/helpers';
import HelpIcon from 'assets/icons/help-grey.svg';
import ArrowBackIcon from 'assets/icons/arrow-back.svg';
import ShareWhiteIcon from 'assets/icons/share-white.svg';
import ArrowForwardIcon from 'assets/icons/arrow-forward.svg';
import ArrowBackWhiteIcon from 'assets/icons/arrow-back-white.svg';
import LighterGreyHelpIcon from 'assets/icons/help-lighter-grey.svg';
import ArrowForwardWhiteIcon from 'assets/icons/arrow-forward-white.svg';

interface ChartHeaderProps {
  title: string;
  tooltip: string;
  prevChart: string;
  nextChart: string;
  currentChartIndex: number;
  handleChartIndex: (newChartIndex: number) => void;
}

const ChartHeader = ({
  title,
  tooltip,
  prevChart,
  nextChart,
  handleChartIndex,
  currentChartIndex
}: ChartHeaderProps) => {
  const isDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;

  return (
    <div className='flex items-center justify-between gap-4 w-full'>
      <div className='flex items-center gap-2'>
        {prevChart ? (
          <CustomTooltip
            id='prev-chart'
            content={prevChart}
            title='Previous Chart'
            className='p-1.5 rounded-full cursor-pointer'
            icon={isDarkMode ? ArrowBackWhiteIcon : ArrowBackIcon}
            onClick={() => handleChartIndex(currentChartIndex - 1)}
          />
        ) : undefined}

        <div className='flex items-center gap-2'>
          <p className='text-[32px] font-semibold'>{title}</p>

          <CustomTooltip
            id='info-chart'
            content={tooltip}
            className='w-7 h-7'
            icon={isDarkMode ? LighterGreyHelpIcon : HelpIcon}
          />
        </div>

        {nextChart ? (
          <CustomTooltip
            id='next-chart'
            title='Next Chart'
            content={nextChart}
            className='p-1.5 rounded-full cursor-pointer'
            onClick={() => handleChartIndex(currentChartIndex + 1)}
            icon={isDarkMode ? ArrowForwardWhiteIcon : ArrowForwardIcon}
          />
        ) : undefined}
      </div>

      <CustomTooltip
        id='share_button'
        content='Share your benchmarks! Click this button to copy a shareable URL to your clipboard'
        icon={isDarkMode ? ShareWhiteIcon : ShareIcon}
        onClick={onShareURLClick}
        className='min-w-[40px] min-h-[40px] cursor-pointer border border-solid border-gray-400 dark:border-gray-650 rounded-full p-[9px] walkthrough-shareable-url'
      />
    </div>
  );
};

export default ChartHeader;
